module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "ch-t"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he historical images in this work come from the files of the US Navy Historical Center. The contemporary photographs come from a US Navy website. Some pictures came from friends that are named. As with all published works, authors depend on friends for assistance in reviewing their work.")]), _vm._v(" "), _c('p', {
    staticClass: "sub-head"
  }, [_vm._v("Notes to the Reader")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note01"
  }, [_vm._v("1.")]), _vm._v(" This book is not a comprehensive history of US Navy destroyers, but rather a broad overview of the subject.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note01"
  }, [_vm._v("2.")]), _vm._v(" All standard ship displacements are in long tons (2,240lb to the ton).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note01"
  }, [_vm._v("3.")]), _vm._v(" Stated displacements only represent a point in time of a destroyer’s service with the US Navy due to ongoing alterations and upgrades.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55ec0aa0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/006_Acknowledgements.vue
// module id = 72
// module chunks = 0